module.exports = __webpack_public_path__ + "img/somos_placa_azul_en.a318112a.jpg";